/*
 * CountSpan es un componente que hace una animacion de conteo al mostrar un cifra.
 * Empezando del cero hasta la cifra a monstra y en el tiempo que se le indique.
 *
 * Para ello tenmos dos parametros que introducieremos en el componerte con unos @input:
 * @number con formato number, que es dicho numero que acabara mostrando
 * @totalTime con formato number tambien, que seria los segundos que se desea que tarde la animacion, ojo en segundo, no en milisegundos
 *
 * La llamada seria un simple html
 * <tech-count-span [number]="varNumero" [totalTime]="varTiempoCarga"></tech-count-span>
 */

import { Component, Input, OnInit } from '@angular/core';
import { interval } from 'rxjs';

@Component({
  selector: 'tech-count-span',
  templateUrl: './count-span.component.html',
  styleUrls: ['./count-span.component.scss'],
})
export class CountSpanComponent implements OnInit {
  @Input() number: number;
  @Input() totalTime: number;
  public count: number = 0;

  constructor() {}

  ngOnInit() {
    const source = interval((this.totalTime * 1000) / this.number);
    source.subscribe((val) => {
      if (val <= this.number) {
        this.count = val;
      }
    });
  }
}
